module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9149d98c7ab70877c624bf7c72952848.png";